<template>
    <div>
        <Head title="Ruta" />
        <h1 class="mb-6 text-3xl font-bold text-gray-900">
            <Link class="text-sky-600 hover:text-sky-800" href="/">
            Dashboard /
            </Link>
            Ruta: {{ nameRoute.description }} {{ formatDate(routeJourney.start_date) }}
        </h1>
        <!-- Summary Cards -->
        <div class="bg-gradient-to-r from-sky-500 to-sky-600 p-6 rounded-xl shadow-lg mb-2">
            <div class="grid grid-cols-2 md:grid-cols-4 gap-4 text-white">
                <InfoCard title="Encargado" :value="nameUser" :image="getIconUrl('markerUser.png')" />
                <InfoCard title="Tiendas de ruta" :value="stores.length" :image="getIconUrl('markerStore.png')" />
                <InfoCard title="Tiendas por visitar" :value="getStoresVisited(routeJourney.status)"
                    :image="getIconUrl('markerBlue.png')" />
                <InfoCard title="Tiendas abiertas" :value="storeOpenedVisited.length"
                    :image="getIconUrl('markerGreen.png')" />
                <InfoCard title="Tiendas cerradas" :value="storeClosedVisited.length"
                    :image="getIconUrl('markerBlack.png')" />
                <InfoCard title="Tiendas no visitadas" :value="getStoresNotVisited(routeJourney.status)"
                    :image="getIconUrl('markerRed.png')" />
                <div class="bg-white bg-opacity-20 p-4 rounded-lg backdrop-blur-lg">
                    <h3 class="text-sm font-medium text-white text-opacity-80">Total pedido</h3>
                    <div class="flex justify-between items-center">
                        <div class="font-bold text-white mt-1">
                            <span class="text-xl">{{ total_order_boxes().boxes }} cajas</span> <br>
                            <span class="text-xl">{{ total_order_boxes().pieces }} piezas</span> <br>
                            <span class="text-base flex justify-end">{{ total_order() }}</span>
                        </div>
                        <p>
                        <div class="bg-white rounded-lg p-1">
                            <img :src="getIconUrl('box.png')" class="w-6 h-6 object-contain" alt="total" />
                        </div>
                        </p>
                    </div>
                </div>
                <InfoCard title="Estatus" :value="statusMessage" :image="statusImage" />
            </div>
        </div>
        <!-- Status store marker -->
        <div class="bg-white rounded-lg shadow p-4 mb-2">
            <h3 class="text-lg font-semibold mb-3">Estatus de la Tienda:</h3>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div class="flex items-center space-x-2">
                    <img :src="getIconUrl('markerStart40.png')" class="w-6 h-6 object-contain" alt="marker green" />
                    <span class="text-sm text-gray-600">Inicio/Fin de ruta</span>
                </div>
                <div class="flex items-center space-x-2">
                    <img :src="getIconUrl('markerGreen.png')" class="w-6 h-6 object-contain" alt="marker green" />
                    <span class="text-sm text-gray-600">Abierta con compra</span>
                </div>
                <div class="flex items-center space-x-2">
                    <img :src="getIconUrl('markerOrange.png')" class="w-6 h-6 object-contain" alt="marker orange" />
                    <span class="text-sm text-gray-600">Abierta dueño ausente</span>
                </div>
                <div class="flex items-center space-x-2">
                    <img :src="getIconUrl('markerYellow.png')" class="w-6 h-6 object-contain" alt="marker yellow" />
                    <span class="text-sm text-gray-600">Abierta con existencia de producto</span>
                </div>
                <div class="flex items-center space-x-2">
                    <img :src="getIconUrl('markerPurple.png')" class="w-6 h-6 object-contain" alt="marker purple" />
                    <span class="text-sm text-gray-600">Abierta sin compra</span>
                </div>
            </div>
        </div>
        <!-- Google Map -->
        <div class="bg-white rounded-xl shadow-md overflow-hidden mb-8">
            <GMapMap :center="center" :zoom="15" map-type-id="roadmap" style="width: 100%; height: 500px;">
                <!-- Start position marker -->
                <GMapMarker :position="startPosition" :clickable="true" :draggable="false" :icon="getStartMarkerIcon()">
                    <GMapInfoWindow :closeclick="true">
                        <div>
                            <h3 class="font-bold text-lg mb-2">Inicio de Ruta</h3>
                            <p>Posición inicial del recorrido</p>
                        </div>
                    </GMapInfoWindow>
                </GMapMarker>
                <GMapMarker v-for="(store, index) in combinedStores" :key="index" :position="store.position"
                    :clickable="true" :draggable="false" :icon="getMarkerIcon(store)" @click="openMarker(store.id)">
                    <GMapInfoWindow :closeclick="true" @closeclick="openMarker(null)"
                        :opened="openedMarkerID === store.id">
                        <div class="px-4 max-w-xs">
                            <h3 class="font-bold text-lg mb-2" :class="getInfoWindowTextColor(store)">
                                {{ getStoreStatus(store) }}
                            </h3>
                            <p class="mb-2"><strong>Tienda:</strong> {{ store.description }}</p>
                            <p v-if="store.status !== 'stand_by'" class="mb-2"><strong>Detalles:</strong> {{
                store.details }}</p>
                            <p v-if="store.status == '1'" class="mb-2">
                                <strong>Pedido:</strong> {{ suma(store.id_route_journey, store.id_route_client) }}
                            </p>
                            <p v-if="store.status == '1'" class="mb-2">
                                <strong>Cajas:</strong> {{ boxes(store.id_route_journey, store.id_route_client) }}
                            </p>
                            <p v-if="store.status !== '0' && store.status !== 'stand_by'" class="text-sm text-gray-600">
                                <i>Visitada: {{ formatDate(store.visit_date) }}</i>
                            </p>
                            <p v-if="store.status == '0'" class="text-sm text-gray-600">
                                <i>Foto:</i><br>
                                <i>{{ store.image }}</i>
                                <i>
                                    <a :href="getImageUrl(store.image)" target="_blank" class="inline-block">
                                        <img :src="getImageUrl(store.image)" alt="Thumbnail"
                                            class="w-48 h-48 object-cover rounded-md hover:opacity-80 transition-opacity" />
                                    </a>
                                </i>
                            </p>
                        </div>
                    </GMapInfoWindow>
                </GMapMarker>
                <GMapMarker v-for="(employee, index) in combinedEmployeePosition" :key="index"
                    :position="employee.position" :clickable="true" :draggable="false"
                    :icon="getEmployeeMarkerIcon(employee.id)" @click="openMarker(employee.id)" />

                <!-- Start position marker -->
                <GMapMarker :position="endPosition" :clickable="true" :draggable="false" :icon="getStartMarkerIcon()">
                    <GMapInfoWindow :closeclick="true">
                        <div>
                            <h3 class="font-bold text-lg mb-2">Final de Ruta</h3>
                            <p>Posición final del recorrido</p>
                        </div>
                    </GMapInfoWindow>
                </GMapMarker>

                <GMapPolyline :path="path" :editable="false" :options="polylineOptions" />
            </GMapMap>
        </div>
        <!-- Tabla dinámica de órdenes -->
        <div v-if="ordersData" id="table-orders" class="bg-white rounded-xl p-4 mb-8">
            <div class="flex justify-between items-center mb-4">
                <h1 class="text-lg font-medium">Ventas en ruta</h1>                
                <button @click="reloadPage"
                    class="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition duration-300">
                    Actualizar
                </button>
            </div>
            <div class="bg-white rounded-md shadow overflow-x-auto">
                <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">Tienda</th>
                    <th class="pb-4 pt-6 px-6">Comentarios</th>
                    <th class="pb-4 pt-6 px-6 text-center">Cajas</th>
                    <th class="pb-4 pt-6 px-6 text-center">Piezas</th>
                    <th class="pb-4 pt-6 px-6 text-right">Total</th>
                    <th class="pb-4 pt-6 px-6">Fecha</th>
                </tr>
                <tr v-for="order in ordersData" :key="order.id"
                    class="hover:bg-gray-100 focus-within:bg-gray-100 cursor-pointer" @click="showOrderDetails(order.id_day_route_client)">                    
                    <td class="border-t px-6 py-4">{{ order.name_store }}</td>
                    <td class="border-t px-6 py-4">{{ order.visit_description }}</td>
                    <td class="border-t px-6 py-4 text-center">{{ order.total_amount_boxes }}</td>
                    <td class="border-t px-6 py-4 text-center">{{ order.total_amount_pieces }}</td>                    
                    <td class="border-t px-6 py-4 text-end">${{ order.total_amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                    <td class="border-t px-6 py-4">{{ formatDate(order.order_date) }}</td>
                </tr>
                <tr>                    
                    <td class="border-t px-6 py-4 font-bold text-end" colspan="4">Total:</td>
                    <td class="border-t px-6 py-4 font-bold text-end">${{ totalSales.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                    <td class="border-t px-6 py-4"></td>
                </tr>

                <tr v-if="ordersData.length === 0">
                    <td class="px-6 py-4 border-t" colspan="5">No se encontraron pedidos para este preventista.</td>
                </tr>
                </table>            
            </div>
        </div>
        <!-- Detalles del pedido Dialog -->
        <div>
            <DialogInput v-if="showDialogDetails" label="Detalles" :title="'Detalles del Pedido'"
                @close="showDialogDetails = false">
                <div class="mt-2 px-2 py-3">
                <p class="text-sm text-gray-500">
                    Tienda: {{ selectedOrder.name_store }}<br>            
                    Fecha: {{ formatDate(selectedOrder.order_date) }} <br>
                </p>
                <p class="text-base">Detalles de visita: {{ selectedOrder.visit_description || 'Sin detalles' }}</p>
                <table class="mt-4 w-full text-sm">
                    <thead>
                    <tr class="text-left font-bold">
                        <th class="py-2 px-4">Producto</th>
                        <th class="py-2 px-4">Unidad</th>
                        <th class="py-2 px-4">Precio</th>
                        <th class="py-2 px-4">Cantidad</th>
                        <th class="py-2 px-4">Descuento</th>
                        <th class="py-2 px-4 text-right">Total</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="detail in selectedOrderDetails" :key="detail.id">
                            <td class="border-t py-2 px-4">{{ detail.name_product }}</td>
                            <td class="border-t py-2 px-4">{{ detail.product_unit || '-' }}</td>
                            <td class="border-t py-2 px-4">${{ detail.price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                            <td class="border-t py-2 px-4">{{ detail.amount }}</td>
                            <td class="border-t py-2 px-4">${{ (detail.promotion_quantity ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                            <td class="border-t py-2 px-4 text-right">${{ ((detail.amount * detail.price) - (detail.promotion_quantity ?? 0)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                        </tr>
                        <tr class="font-bold">
                            <td class="border-t py-2 px-4" colspan="4"></td>
                            <td class="border-t py-2 px-4 text-right">Total:</td>
                            <td class="border-t py-2 px-4 text-right">${{ calculateOrderDetailsTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </DialogInput>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Search from '@/Shared/Search'
import DialogInput from '@/Shared/Dialog'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Icon from '@/Shared/Icon'
import Pagination from '@/Shared/Pagination'
import InputFile from '@/Shared/InputFile'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import InfoCard from '@/Shared/InfoCard'

export default {
    components: {
        Head,
        Link,
        Search,
        DialogInput,
        LoadingButton,
        TextInput,
        Icon,
        Pagination,
        SelectInput,
        TextareaInput,
        InputFile,
        InfoCard,
    },
    layout: Layout,
    props: {
        storeClosedVisited: Array,
        storeNotVisited: Array,
        storeOpenedVisited: Array,
        orders: Array,
        routeJourney: Array,
        nameRoute: Array,
        nameUser: String,
        points: Array,
        stores: Array,
        centerNearest: Array,
        centerRandom: Array,
        lat_start_route: Number,
        lon_start_route: Number,
        lat_end_route: Number,
        lon_end_route: Number,
        ordersData: Array,
        ordersDetailsData:Array,
    },
    remember: 'form',
    data() {
        return {
            openedMarkerID: null,
            activeMarkers: {},
            center: null,
            path: this.points,
            polylineOptions: {
                strokeColor: '#035DC3',       // Color de la línea
                strokeOpacity: 0.8,           // Opacidad de la línea
                strokeWeight: 4               // Ancho de la línea
            },
            startPosition: {
                lat: Number(this.lat_start_route) || null,
                lng: Number(this.lon_start_route) || null
            },
            endPosition: {
                lat: Number(this.lat_end_route) || null,
                lng: Number(this.lon_end_route) || null
            },
            showDialogDetails: false,
            selectedOrderDetails: [],
            selectedOrder: null,
        }
    },
    computed: {
        combinedStores() {
            return this.stores.map(store => {

                const visitedStore = [...this.storeOpenedVisited, ...this.storeClosedVisited, ...this.storeNotVisited].find(s => s.id_client === store.id);

                const combinedStore = {
                    ...store,
                    position: {
                        lat: Number(store.latitude),
                        lng: Number(store.longitude)
                    },
                    status: visitedStore ? (visitedStore.open_store !== undefined ? visitedStore.open_store : 'stand_by') : 'stand_by',
                    details: visitedStore ? (visitedStore.description !== undefined ? visitedStore.description : '') : '',
                    image: visitedStore ? (visitedStore.image !== undefined ? visitedStore.image : '') : '',
                    visit_date: visitedStore ? visitedStore.visit_date : null,
                    id_day_route_client: visitedStore ? visitedStore.id_day_route_client : null
                };

                return combinedStore;
            });
        },
        combinedEmployeePosition() {
            const allVisitedStores = [...this.storeOpenedVisited, ...this.storeClosedVisited, ...this.storeNotVisited];

            // Create a map of store descriptions for quick lookup
            const storeDescriptions = new Map(this.stores.map(store => [store.id, store.description]));

            const result = allVisitedStores.map(visitedStore => {
                const position = {
                    lat: Number(visitedStore.lat_employee),
                    lng: Number(visitedStore.lon_employee)
                };

                return {
                    id: visitedStore.id_client,
                    store_name: storeDescriptions.get(visitedStore.id_client) || 'Unknown Store',
                    position: position,
                    status: visitedStore.open_store ?? 'stand_by',
                    details: visitedStore.description ?? '',
                    image: visitedStore.image ?? '',
                    visit_date: visitedStore.visit_date,
                    id_day_route_client: visitedStore.id_day_route_client
                };
            }).filter(employee => {
                const isValid = !isNaN(employee.position.lat) && !isNaN(employee.position.lng);
                if (!isValid) {
                    console.log('Filtered out invalid employee position for store:', employee.id);
                }
                return isValid;
            });
            // console.log('Final combinedEmployeePosition result:', JSON.stringify(result, null, 2));
            return result;
        },
        statusMessage() {
            if (this.routeJourney.status === 0) return 'Finalizada';
            if (this.routeJourney.status === 2) return 'Incompleta';
            return 'Activa';
        },
        statusImage() {
            return this.routeJourney.status === 0 ? this.getIconUrl('routeClose.png') : this.getIconUrl('routeOpen.png');
        },
        totalSales() {
            return this.ordersData.reduce((sum, order) => sum + order.total_amount, 0);
        },
        calculateOrderDetailsTotal() {
            return this.selectedOrderDetails.reduce((total, detail) => {
                let desc = detail.promotion_quantity ?? 0;
                return total + ((detail.amount * detail.price) - desc);
            }, 0);
        },
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/routes', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        openMarker(id) {
            // this.openedMarkerID = id
            if (this.openedMarkerID === id) {
                this.activeMarkers[id] = false; // Restaurar el ícono
                this.openedMarkerID = null; // Cerrar el marcador
            } else {
                // Si se abre un nuevo marcador, cambiar el ícono del marcador abierto
                if (this.openedMarkerID !== null) {
                    this.activeMarkers[this.openedMarkerID] = false; // Restaurar el ícono del anterior
                }
                this.activeMarkers[id] = true; // Activar el ícono del nuevo marcador
                this.openedMarkerID = id; // Guardar el ID del marcador abierto
            }
        },
        getMarkerIcon(store) {
            const markerIcons = {
                '0': '../../img/markerBlack.png',
                '1': '../../img/markerGreen.png',
                '2': '../../img/markerOrange.png',
                '3': '../../img/markerBlue.png',
                '4': '../../img/markerYellow.png',
                '5': '../../img/markerPurple.png',
                '6': '../../img/markerRed.png'
            };

            // Get the icon based on the store status
            const icon = markerIcons[String(store.status)];

            // Return the icon if it exists; otherwise, return the default based on routeJourney status
            if (icon) {
                return icon;
            }

            return this.routeJourney.status == 2
                ? '../../img/markerRed.png'
                : '../../img/markerSky.png';
        },
        getInfoWindowStyle(store) {
            const baseStyle = "font-size: large; border-radius: 10px; display: flex; justify-content: center; text-align: center;";

            const infoWindowStyles = {
                '0': "background-color: salmon;",
                '1': "color: white; background-color: green;",
                '2': "color: white; background-color: green;",
                '3': "color: white; background-color: green;",
                '4': "color: white; background-color: green;",
                '5': "color: white; background-color: green;",
                '6': "color: white; background-color: red;"
            };

            // Get the style based on the store status
            const style = infoWindowStyles[String(store.status)];

            // Return the style if it exists; otherwise, return the default based on routeJourney status
            if (style) {
                return baseStyle + " " + style;
            }

            return baseStyle + " " + (this.routeJourney.status == 2
                ? "color: white; background-color: red;"
                : "background-color: gray;");
        },
        getStoreStatus(store) {
            const openStatuses = ['1', '2', '3', '4', '5'];
            const status = String(store.status);

            if (openStatuses.includes(status)) {
                return 'ABIERTA';
            }
            switch (status) {
                case '0':
                    return 'CERRADA';
                case '6':
                    return 'NO VISITADA';
                default:
                    return this.routeJourney.status == 2 ? 'NO VISITADA' : 'EN RUTA';
            }
        },
        suma(id_route_journey, id_route_client) {
            const ordersForStore = this.orders.filter(order => order.id_route_journey === id_route_journey && order.id_day_route_client === id_route_client);
            let total = 0;
            ordersForStore.forEach(order => {
                total += order.amount * order.price;
            });
            return total.toFixed(2);
        },
        boxes(id_route_journey, id_route_client) {
            const ordersForStore = this.orders.filter(order => order.id_route_journey === id_route_journey && order.id_day_route_client === id_route_client);
            let totalBoxes = 0;
            ordersForStore.forEach(order => {
                totalBoxes += order.amount;
            });
            return totalBoxes;
        },
        total_order() {
            let total = 0;
            this.orders.forEach(objeto => {
                let desc = objeto.promotion_quantity ?? 0;
                total += (objeto.amount * objeto.price) - desc;

            })
            // return total.toFixed(2);
            return '$' + total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        total_order_boxes() {
            let boxes = 0;
            let pieces = 0;
            this.orders.forEach(objeto => {
                if (objeto.unit == 0) {
                    boxes += objeto.amount;
                } else {
                    pieces += objeto.amount;
                }

            })
            return {
                boxes: boxes,
                pieces: pieces
            };
        },
        formatDate(date_str) {
            const date_route = new Date(date_str)
            const day_date_route = date_route.getDate().toString().padStart(2, '0')
            const month_date_route = (date_route.getMonth() + 1).toString().padStart(2, '0')
            const year_date_route = date_route.getFullYear()

            // Añadimos la hora, minutos y segundos
            const hours = date_route.getHours().toString().padStart(2, '0')
            const minutes = date_route.getMinutes().toString().padStart(2, '0')
            const seconds = date_route.getSeconds().toString().padStart(2, '0')

            return `${day_date_route}/${month_date_route}/${year_date_route} ${hours}:${minutes}:${seconds}`
        },
        getInfoWindowTextColor(store) {
            switch (String(store.status)) {
                case '1':
                case '2':
                case '3':
                case '4':
                case '5':
                    return 'text-green-600';
                case '0':
                    return 'text-red-600';
                default:
                    return 'text-gray-600';
            }
        },
        getImageUrl(image) {
            // Adjust this path according to your project structure
            return `/imagenes/${image}`
        },
        getIconUrl(image) {
            // Adjust this path according to your project structure
            return `/img/${image}`
        },
        getStartMarkerIcon() {
            // You can use a different icon for the start position
            return '../../img/markerStart40.png';
        },
        getEmployeeMarkerIcon(id) {
            // Retorna el ícono basado en si el marcador está activo o no
            return this.activeMarkers[id] ? '/img/markerPhoneSky.png' : '/img/markerWorker.png';
        },
        getStoresNotVisited(status) {
            console.log(status);
            let notVisited = this.storeNotVisited.length;
            let stores = this.stores.length;
            let sumaStores = this.storeOpenedVisited.length + this.storeClosedVisited.length;

            console.log(notVisited, stores, sumaStores);

            if (status === 2) {
                let total = stores - sumaStores;
                return total;  // Proteger contra valores negativos
            }

            if (status === 0) {
                if (stores >= sumaStores) {
                    return stores - sumaStores >= 0 ? stores - sumaStores : 0;  // Proteger contra valores negativos
                } else {
                    return notVisited;
                }
            }

            // Caso por defecto si no es status 0 o 2
            return notVisited;
        },
        getStoresVisited(status) {
            console.log(status);
            let notVisited = this.storeNotVisited.length;
            let stores = this.stores.length;
            let sumaStores = this.storeOpenedVisited.length + this.storeClosedVisited.length;

            console.log(notVisited, stores, sumaStores);

            if (status === 2 || status == 0) {
                return 0;  // Proteger contra valores negativos
            } else {
                return stores - sumaStores;
            }
        },
        showOrderDetails(id_day_route_client) {
            // Encontrar la orden seleccionada
            this.selectedOrder = this.ordersData.find(
                order => order.id_day_route_client === id_day_route_client
            );
            
            // Filtrar los detalles que corresponden a esta orden
            this.selectedOrderDetails = this.ordersDetailsData.filter(
                detail => detail.id_day_route_client === id_day_route_client
            );

            // console.log(this.selectedOrder, this.selectedOrderDetails);           
            this.showDialogDetails = true;
        },
        reloadPage() {
            window.location.hash = 'table-orders'; // Agrega el fragmento a la URL
            location.reload(); // Recarga la página completa
        },
    },
    mounted() {
        const lat = Number(this.centerNearest?.lat) || 17.056759;
        const lng = Number(this.centerNearest?.lng) || -96.656421;
        this.center = { lat: lat, lng: lng };

        console.log(this.points);

        if (window.location.hash === '#table-orders') {
        const tableOrders = document.getElementById('table-orders');
        if (tableOrders) {
                tableOrders.scrollIntoView({ behavior: 'smooth' });
            }
        }
    },
}
</script>
